import { ASSETS } from "@/lib/assets";
import { scrollToId } from "@/lib/scroll";

const scrollTo = (href) => scrollToId(href);

export const Footer = () => (
  <footer className="relative border-t border-white/10 pt-20 pb-10 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-10 mb-20">
        <div className="md:col-span-5">
          <img src={ASSETS.logoWhite} alt="ASYA" className="h-6 w-auto mb-6" />
          <p className="max-w-sm text-sm text-muted-foreground leading-relaxed">
            The closed-loop skincare system. Diagnose, personalize and deliver — by Quantum Origin Inc. Debuting at CES 2027.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="overline mb-6">Explore</p>
          <ul className="space-y-3 text-sm">
            {[["The System", "#system"], ["How it works", "#how"], ["Pricing", "#pricing"], ["FAQ", "#faq"]].map(([l, h]) => (
              <li key={h}>
                <button onClick={() => scrollTo(h)} className="text-muted-foreground hover:text-foreground transition-colors">
                  {l}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline mb-6">Get access</p>
          <button
            data-testid="footer-waitlist-button"
            onClick={() => scrollTo("#waitlist")}
            className="text-sm text-foreground hover:text-primary transition-colors"
          >
            Join the waitlist →
          </button>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pt-8 border-t border-white/10">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          © 2027 Quantum Origin Inc. · 9 US Patents
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          Personalized skincare, delivered.
        </p>
      </div>
    </div>
  </footer>
);
